import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'
import { queryString } from '../../utils/queryString'
import { Order } from './types'

export const orderSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    getOrders: build.query<
      any,
      { page?: number; limit?: number; type?: string; status?: string }
    >({
      query: ({ page = 1, limit = 10, type = '' }) => {
        const qs = queryString({ page, limit, type })
        return `${urlConfig.ordersBaseUrl}/orders/my-orders?${qs}`
      },
      transformResponse: (response: any, meta, args) => ({
        ...response,
        per_page: args.limit,
      }),
      providesTags: (result, error, arg) =>
        result
          ? [
              ...result.data.map(({ _id }: { _id: string }) => ({
                type: 'Orders' as const,
                id: _id,
              })),
              { type: 'Orders', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Orders', id: 'PARTIAL-LIST' }],
    }),
    getOrdersById: build.query<Order, any>({
      query: id => `${urlConfig.ordersBaseUrl}/orders/id/${id}`,
      providesTags: (result, error, id) => [{ type: 'Orders', id }],
    }),
    getStats: build.query<any, void>({
      query: () => `${urlConfig.ordersBaseUrl}/orders/stats`,
    }),
    createOrder: build.mutation<any, FormData>({
      query: body => ({
        url: `${urlConfig.ordersBaseUrl}/orders`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Orders'],
    }),
  }),
})

export const {
  useGetOrdersByIdQuery,
  useGetOrdersQuery,
  useCreateOrderMutation,
  useGetStatsQuery,
} = orderSlice
